import {
  Button,
  Input,
  Loader,
  Modal,
  Placeholder,
  Radio,
  RadioGroup,
} from "rsuite";
import React from "react";
import { Search } from "lucide-react";

import { saveReplaceMeal } from "./saveReplaceMeal";

export const ReplacementModal = ({
  replacementModalStatus,
  closeReplaceModal,
  replacementModalTitle,
  activeFreeMeals,
  replaceModalSearch,
  selectFreeMeal,
  isLoading1,
  selectedFreeMeal,
  activeMeal,
  sync,
  setIsLoading1,
  handleNotfound,
}) => {
  return (
    <Modal open={replacementModalStatus} onClose={closeReplaceModal}>
      <Modal.Header className="!p-0">
        <Modal.Title className="text-center !p-0 !text-base md:!text-xl	!font-bold !text-[#535353]">
          {replacementModalTitle}
        </Modal.Title>
        <span className="w-full block text-center mt-1 text-sm md:text-base text-[#535353]">
          انتخاب جایگزین دلخواه برای این وعده
        </span>
      </Modal.Header>
      <Modal.Body className="!mt-4 md:!mt-6 customScrollbar">
        {activeFreeMeals ? (
          <div className="free-meals-container">
            <div className="search-box mb-4 ">
              <div className="group relative">
                <label
                  htmlFor={"search"}
                  className={
                    "absolute z-10 top-[14px] right-2 md:top-5 md:right-4"
                  }
                >
                  <Search
                    className={`!w-5 !h-5 md:!w-6 md:!h-6 group-focus-within:[&_path]:!text-[#0EAD98] [&_circle]:!text-[#BFC0C3] group-focus-within:[&_circle]:!text-[#0EAD98] [&_path]:!text-[#BFC0C3] `}
                  />
                </label>
                <Input
                  onChange={(value) => replaceModalSearch(value)}
                  className="focus:!outline-none !text-sm md:!text-base !pr-9 md:!pr-12 !h-12 md:!h-16 !rounded-lg md:!rounded-xl"
                  placeholder="جستجو ..."
                />
              </div>
            </div>

            <div
              className={`free-meals pl-2 max-h-[${
                selectedFreeMeal ? "40vh" : "50vh"
              }] overflow-y-scroll customScrollbar`}
            >
              <RadioGroup name="free_meals ">
                {activeFreeMeals.map((activeFreeMeal, activeFreeMealIndex) => {
                  return (
                    <Radio
                      dir="rtl"
                      onChange={(e) => selectFreeMeal(activeFreeMeal)}
                      key={activeFreeMealIndex}
                      value={activeFreeMeal.id}
                      className="!ml-0"
                    >
                      {activeFreeMeal.foods
                        .map((food) => food.title)
                        .join("، ")}
                    </Radio>
                  );
                })}
              </RadioGroup>
            </div>
          </div>
        ) : (
          <>
            <Placeholder.Paragraph rows={8} />
            <Loader backdrop content="درحال بارگزاری..." vertical />
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        {selectedFreeMeal ? (
          <Button
            className="btn-replace-modal-save md:!h-14 md:!text-base"
            disabled={isLoading1}
            onClick={() =>
              saveReplaceMeal({
                activeMeal,
                selectedFreeMeal,
                closeReplaceModal,
                sync,
                setIsLoading1,
                handleNotfound,
              })
            }
            appearance="primary"
          >
            جایگزینی
            {isLoading1 && <Loader size="xs" className="mx-2" />}
          </Button>
        ) : (
          ""
        )}
      </Modal.Footer>
    </Modal>
  );
};
